<template>
  <div id="container">
    <v-container wrap>
      <v-dialog v-model="enable" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-icon color="orange">warning</v-icon>
          </v-card-title>

          <v-card-text v-html="description"></v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat="flat" @click="cancel">
              {{ $t('generic.cancel') }}
            </v-btn>
            <v-btn color="primary darken-1" flat="flat" @click="ok" v-if="!std"
              >Sí, Desactivar</v-btn
            >
            <v-btn color="primary darken-1" flat="flat" @click="ok" v-else
              >Sí, Activar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ['value', 'title', 'description', 'std'],
  data() {
    return {
      enable: this.value,
    }
  },
  watch: {
    value() {
      this.enable = this.value
    },
  },
  methods: {
    cancel() {
      this.$emit('input', !this.value)
      this.$emit('desition', false)
    },
    ok() {
      this.$emit('input', !this.value)
      this.$emit('desition', true)
    },
  },
}
</script>

<style></style>
